import {
  DashboardTypes,
  GetCustomValueHistoryQuery,
  GetCustomValueHistoryQueryVariables,
  GetCustomValueQuery,
  SaveCustomValueMutation,
  mediaSource,
} from 'API';
import { API } from 'aws-amplify';
import { useCampaignContext } from 'context/CampaignContext';
import { CommentsContext } from 'context/CommentsContext';
import { PublishContext } from 'context/PublishContext';
import { saveCustomValue } from 'graphql/mutations';
import { getCustomValueHistory } from 'graphql/queries';
import { useContext, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { IconButton } from './style/Global';
import { Modal } from './NewPortal/Header/AddCampaignModal';
import { HeadModul, ModulContainer } from './Main/table/TableStyles';
import { IoMdClose } from 'react-icons/io';
import { iconList } from 'assets/newAssets/SVG/additionalIconsForLinks/iconList';

type Props = {
  componentID: string;
  location: string;
  getTitleFromAPI?: (title: string, subtitle: string, format: string) => void;
  setIsKPIeditable?: (arg: boolean) => void;
  defaultTitle?: string;
  defaultSubtitle?: string;
  planMode?: boolean;
  noWrapper?: boolean;
  plannedComponentID?: string;
};

export const KPItoS3 = (props: Props) => {
  const { activeCampaign, dashType } = useCampaignContext();
  const { KPIValues } = useContext(CommentsContext);
  const { updateOLArray, publishedData } = useContext(PublishContext);

  const [labelValue, setLabelValue] = useState(props.defaultTitle ?? 'Custom value');
  const [subtitle, setSubtitle] = useState(props.defaultSubtitle ?? 'Custom value');
  const [format, setformat] = useState('number');
  const formatoptions = ['number', 'percentage'];

  const [val, setVal] = useState<number | null>(null);
  const [plannedVal, setPlannedVal] = useState<number | null>(null);
  const [edit, setEdit] = useState(false);
  const handleSave = () => {
    val === 0 ? setVal(null) : setVal(val);
    labelValue === '' ? setLabelValue('Custom value') : setLabelValue(labelValue);
    subtitle === '' ? setSubtitle('Custom value') : setSubtitle(subtitle);
    format === '' ? setformat('number') : setformat(format);
    CustomValueSave(val);
    // setEdit(!edit)
  };

  useEffect(() => {
    if (activeCampaign?.campaignId && activeCampaign.authorized) {
      GetCustomValue();
      GetPlannedCustomValue();
    }
  }, [activeCampaign]);

  useEffect(() => {
    props.setIsKPIeditable && props.setIsKPIeditable(edit);
  }, [edit]);

  useEffect(() => {
    if (props.location === 'customReport') {
      setEdit(true);
    }
  }, [props.location]);

  useEffect(() => {
    if (publishedData && !activeCampaign?.authorized) {
      publishedData.forEach((e) => {
        if (e.position === props.componentID) {
          setVal(e.outputlocation);
          setLabelValue(e.title);
          setSubtitle(e.outputlocation_cc);
          setformat(e.outputlocationTotal_cc);

          props.getTitleFromAPI &&
            props.getTitleFromAPI(
              e.title ? (e.title as string) : '',
              e.outputlocation_cc !== null ? (e.outputlocation_cc as string) : '',
              e.outputlocationTotal_cc ? (e.outputlocationTotal_cc as string) : '',
            );
        }
      });
    }
  }, [publishedData]);

  const theme = useTheme();
  async function CustomValueSave(value: any) {
    const vars =
      props.location === 'summary'
        ? {
            CustomValue: {
              campaignId: activeCampaign?.campaignId,
              dashboardType: 'OVERALL',
              position: props.componentID,
              floatValue: value === 0 ? null : value,
              label: labelValue === '' ? 'Custom value' : labelValue,
            },
          }
        : props.location === 'Cinema' ||
            props.location === 'Print' ||
            props.location === 'OOH' ||
            props.location === 'BVOD'
          ? {
              CustomValue: {
                campaignId: activeCampaign?.campaignId,
                dashboardType: props.location.toUpperCase(),
                position: props.componentID,
                floatValue: value === 0 ? null : value,
                label: labelValue === '' ? 'Custom value' : labelValue,
                subtitle: subtitle === '' ? 'Custom value' : subtitle,
                format: format === '' ? 'number' : format,
              },
            }
          : {
              CustomValue: {
                campaignId: activeCampaign?.campaignId,
                dashboardType:
                  mediaSource[
                    dashType === DashboardTypes.HOME || dashType === DashboardTypes.FLOWCHART
                      ? 'OVERALL'
                      : (dashType as keyof typeof mediaSource)
                  ],
                position: props.componentID,
                floatValue: value === 0 ? null : value,
              },
            };

    try {
      const response = (await API.graphql({
        query: saveCustomValue,
        variables: vars,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: SaveCustomValueMutation };
      const placeholdersObject = {
        position: props.componentID,
        outputlocation: value,
        title: labelValue === '' ? 'Custom value' : labelValue,
        outputlocation_cc: subtitle === '' ? 'Custom value' : subtitle,
        outputlocationTotal_cc: format === '' ? 'number' : format,
      };

      updateOLArray(placeholdersObject);
      props.getTitleFromAPI && props.getTitleFromAPI(labelValue, subtitle, format);
      if (props.plannedComponentID && plannedVal !== null) {
        await API.graphql({
          query: saveCustomValue,
          variables: {
            CustomValue: {
              campaignId: activeCampaign?.campaignId,
              dashboardType: props.location.toUpperCase(),
              position: props.plannedComponentID,
              floatValue: plannedVal === 0 ? null : plannedVal,
              label: labelValue === '' ? 'Custom value' : labelValue,
              subtitle: subtitle === '' ? 'Custom value' : subtitle,
              format: format === '' ? 'number' : format,
            },
          },
          authMode: 'AMAZON_COGNITO_USER_POOLS',
        });
        updateOLArray({
          position: props.plannedComponentID,
          outputlocation: plannedVal,
          title: labelValue,
          outputlocation_cc: subtitle,
          outputlocationTotal_cc: format,
        });
      }
      setEdit(!edit);
    } catch (e) {
      console.log('ERROR SAVING CUSTOM VALUE TEMPLATE', e);
      setVal(null);
    }
  }

  async function GetCustomValue() {
    try {
      const response = (await API.graphql({
        query: getCustomValueHistory,
        variables: {
          campaignId: activeCampaign?.campaignId,
          dashboardType:
            dashType === DashboardTypes.HOME || dashType === DashboardTypes.FLOWCHART
              ? 'OVERALL'
              : dashType === DashboardTypes.TV
                ? 'BVOD'
                : (dashType as keyof typeof mediaSource),
          position: props.componentID,
        } as GetCustomValueHistoryQueryVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: GetCustomValueHistoryQuery };

      const resArray = response.data.getCustomValueHistory;

      // props.getTitleFromAPI && props.getTitleFromAPI("SSSSS")

      if (resArray !== null && resArray !== undefined) {
        //OVO ZNACI DA JE NESTO BILO SPREMLJENO I DA POSTOJI NEKA VRIJEDNOST TAKO DA MOGU PROVJERITI DA LI IMA NEKOG TITLEA
        // AKO TITLE NE POSTOJI A POSTOJI VRIJEDNOST ONDA CE MI TITLE BITI PERSOONS
        if (resArray.some((e) => e?.position === props.componentID && e?.status === 'ACTIVE')) {
          // in resArray, find the one with the latest created_at date
          let latestDate = new Date(0);
          let latestComment = resArray[0];
          resArray?.forEach((e) => {
            if (new Date(e?.createdAt as string) > latestDate) {
              latestDate = new Date(e?.createdAt as string);
              latestComment = e;
            }
          });
          if (latestComment) {
            setVal(latestComment.floatValue === null ? null : (latestComment.floatValue as number));
            const placeholdersObject = {
              position: props.componentID,
              outputlocation: latestComment?.floatValue,
              title: latestComment.label !== null ? (latestComment.label as string) : '',
              outputlocation_cc: latestComment.subtitle !== null ? (latestComment.subtitle as string) : '',
              outputlocationTotal_cc: latestComment.format !== null ? (latestComment.format as string) : '',
            };
            setLabelValue(latestComment.label === null ? 'Custom value' : (latestComment.label as string));
            setSubtitle(latestComment.subtitle === null ? 'Custom value' : (latestComment.subtitle as string));
            setformat(latestComment.format === null ? 'Custom value' : (latestComment.format as string));
            props.getTitleFromAPI &&
              props.getTitleFromAPI(
                latestComment.label !== null ? (latestComment.label as string) : '',
                latestComment.subtitle !== null ? (latestComment.subtitle as string) : '',
                latestComment.format !== null ? (latestComment.format as string) : '',
              );
            setTimeout(() => {
              updateOLArray(placeholdersObject);
            }, 5000);
          }
        } else {
          // AKO NEMA NISTA SPREMLJENO ONDA CE MI TITLE BITI CUSTOM VALUE
          props.getTitleFromAPI && props.getTitleFromAPI(props.defaultTitle ?? 'Custom value', props.defaultSubtitle ?? 'Custom value', 'number');
          // readOldFromComment()
        }
      } else {
        // AKO NEMA NISTA SPREMLJENO ONDA CE MI TITLE BITI CUSTOM VALUE
        props.getTitleFromAPI && props.getTitleFromAPI(props.defaultTitle ?? 'Custom value', props.defaultSubtitle ?? 'Custom value', 'number');
        // readOldFromComment()
      }
    } catch (e) {
      console.log('ERROR GET CUSTOM VALUEE', e);
    }
  }

  async function GetPlannedCustomValue() {
    if (!props.plannedComponentID) return;
    try {
      const response = (await API.graphql({
        query: getCustomValueHistory,
        variables: {
          campaignId: activeCampaign?.campaignId,
          dashboardType:
            dashType === DashboardTypes.HOME || dashType === DashboardTypes.FLOWCHART
              ? 'OVERALL'
              : dashType === DashboardTypes.TV
                ? 'BVOD'
                : (dashType as keyof typeof mediaSource),
          position: props.plannedComponentID,
        } as GetCustomValueHistoryQueryVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: GetCustomValueHistoryQuery };
      const resArray = response.data.getCustomValueHistory;
      if (resArray && resArray.some((e) => e?.position === props.plannedComponentID && e?.status === 'ACTIVE')) {
        let latestDate = new Date(0);
        let latestComment = resArray[0];
        resArray?.forEach((e) => {
          if (new Date(e?.createdAt as string) > latestDate) {
            latestDate = new Date(e?.createdAt as string);
            latestComment = e;
          }
        });
        if (latestComment) {
          setPlannedVal(latestComment.floatValue === null ? null : (latestComment.floatValue as number));
        }
      }
    } catch (e) {
      console.log('ERROR GET PLANNED CUSTOM VALUE', e);
    }
  }

  // console.log("LOCATION", props.location, props.componentID)

  const editIcon = iconList.find((e) => e === 'edit');
  return (
    <>
      {activeCampaign?.authorized && !props.planMode && (
        <div
          onClick={() => {
            activeCampaign?.authorized && setEdit(!edit);
          }}
          className="testtt"
          style={{ position: 'absolute', top: 0, right: 0 }}
        >
          <button className="icon material-symbols-outlined">{editIcon}</button>
        </div>
      )}

      {props.location === 'summary' /* !edit && */ && (
        <h1
          onClick={() => {
            activeCampaign?.authorized && setEdit(!edit);
          }}
          style={{ fontSize: '0.6vw' }}
        >
          {labelValue}
        </h1>
      )}

      {props.noWrapper ? (
        <>
          {props.planMode ? (
            <h2
              className="tooltip"
              onClick={() => { activeCampaign?.authorized && setEdit(!edit); }}
            >
              {val === null ? 'NaN' : Intl.NumberFormat('en-DK', { notation: 'compact', maximumFractionDigits: 1 }).format(Number(val))}
              {(dashType === 'CINEMA' || dashType === 'PRINT' || dashType === 'OOH' || dashType === 'TV') && format === 'percentage' && '%'}
              <span className="tooltiptext">
                {val === null ? 'NaN' : Intl.NumberFormat('en-DK', { maximumFractionDigits: 1 }).format(Number(val))}
                {(dashType === 'CINEMA' || dashType === 'PRINT' || dashType === 'OOH' || dashType === 'TV') && format === 'percentage' && '%'}
              </span>
            </h2>
          ) : (
            <h4 onClick={() => { activeCampaign?.authorized && setEdit(!edit); }}>
              {val === null ? 'NaN' : Intl.NumberFormat('en-DK', { notation: 'compact', maximumFractionDigits: 1 }).format(Number(val))}
              {props.componentID.includes('2') && dashType !== 'CINEMA' && dashType !== 'PRINT' && dashType !== 'OOH' && dashType !== 'TV' && '%'}
              {(dashType === 'CINEMA' || dashType === 'PRINT' || dashType === 'OOH' || dashType === 'TV') && format === 'percentage' && '%'}
            </h4>
          )}
        </>
      ) : (
      <div className="valueFlex">
        {/* {!edit && */}
        {props.planMode ? (
          <h2
            className="tooltip"
            onClick={() => {
              activeCampaign?.authorized && setEdit(!edit);
            }}
          >
            {val === null
              ? 'NaN'
              : Intl.NumberFormat('en-DK', { notation: 'compact', maximumFractionDigits: 1 }).format(Number(val))}
            {(dashType === 'CINEMA' || dashType === 'PRINT' || dashType === 'OOH' || dashType === 'TV') &&
              format === 'percentage' &&
              '%'}
            <span className="tooltiptext">
              {val === null ? 'NaN' : Intl.NumberFormat('en-DK', { maximumFractionDigits: 1 }).format(Number(val))}
              {(dashType === 'CINEMA' || dashType === 'PRINT' || dashType === 'OOH' || dashType === 'TV') &&
                format === 'percentage' &&
                '%'}
            </span>
          </h2>
        ) : (
        <h4
          onClick={() => {
            activeCampaign?.authorized && setEdit(!edit);
          }}
        >
          {val === null
            ? 'NaN'
            : Intl.NumberFormat('en-DK', { notation: 'compact', maximumFractionDigits: 1 }).format(Number(val))}
          {props.componentID.includes('2') &&
            dashType !== 'CINEMA' &&
            dashType !== 'PRINT' &&
            dashType !== 'OOH' &&
            dashType !== 'TV' &&
            '%'}
          {(dashType === 'CINEMA' || dashType === 'PRINT' || dashType === 'OOH' || dashType === 'TV') &&
            format === 'percentage' &&
            '%'}
        </h4>
        )}
        {/* } */}
        {props.plannedComponentID && (
          <div className="plan">
            <h2>Planned</h2>
            <h2 className="tooltip">
              {plannedVal === null
                ? 'NaN'
                : Intl.NumberFormat('en-DK', { notation: 'compact', maximumFractionDigits: 1 }).format(Number(plannedVal))}
              {(dashType === 'CINEMA' || dashType === 'PRINT' || dashType === 'OOH' || dashType === 'TV') &&
                format === 'percentage' &&
                '%'}
              <span className="tooltiptext">
                {plannedVal === null
                  ? 'NaN'
                  : Intl.NumberFormat('en-DK', { maximumFractionDigits: 1 }).format(Number(plannedVal))}
                {(dashType === 'CINEMA' || dashType === 'PRINT' || dashType === 'OOH' || dashType === 'TV') &&
                  format === 'percentage' &&
                  '%'}
              </span>
            </h2>
          </div>
        )}
        {/* {edit && <EditDataModal setEdit={setEdit}></EditDataModal>} */}
      </div>
      )}
      {edit && (
        <Modal>
          <HeadModul>
            <button type="button" className="x" onClick={() => setEdit(false)}>
              {' '}
              <IoMdClose className="closeIcon" />
            </button>
            <ModulContainer>
              <h1>Edit Data</h1>
              <div className="editDataForm">
                {(props.location === 'summary' ||
                  props.location === 'Cinema' ||
                  props.location === 'customReport' ||
                  props.location === 'Print' ||
                  props.location === 'OOH' ||
                  props.location === 'BVOD') && (
                  <>
                    <h1>
                      Label Title
                      <input defaultValue={labelValue} onChange={(e) => setLabelValue(e.target.value)} type="text" />
                    </h1>
                    {(props.location === 'Cinema' ||
                      props.location === 'Print' ||
                      props.location === 'OOH' ||
                      props.location === 'BVOD') && (
                      <h1>
                        Label Subtitle
                        <input defaultValue={subtitle} onChange={(e) => setSubtitle(e.target.value)} type="text" />
                      </h1>
                    )}
                    {(props.location === 'Cinema' ||
                      props.location === 'Print' ||
                      props.location === 'OOH' ||
                      props.location === 'BVOD') && (
                      <h1>
                        Value Format
                        <select defaultValue={labelValue} onChange={(e) => setformat(e.target.value)}>
                          {formatoptions.map((e) => (
                            <option value={e}>{e}</option>
                          ))}
                        </select>
                      </h1>
                    )}
                  </>
                )}

                <h1>
                  Value
                  <input
                    defaultValue={val === null ? 'NaN' : val}
                    type="number"
                    onChange={(e) => setVal(Number(e.target.value))}
                  />{' '}
                </h1>
                {props.plannedComponentID && (
                  <h1>
                    Planned Value
                    <input
                      defaultValue={plannedVal === null ? 'NaN' : plannedVal}
                      type="number"
                      onChange={(e) => setPlannedVal(Number(e.target.value))}
                    />
                  </h1>
                )}
              </div>

              <div style={{ display: 'flex', marginTop: '10px', gap: '10px', marginLeft: 'auto', marginRight: '10px' }}>
                <IconButton type="button" onClick={handleSave}>
                  Save
                </IconButton>
                <IconButton type="button" onClick={() => setEdit(false)}>
                  Cancel
                </IconButton>
              </div>
            </ModulContainer>
          </HeadModul>
        </Modal>
      )}
    </>
  );
};
